import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import {
  GetBannerResponse,
  GetLogoResponse,
  WagerResponseType,
} from "api/retrieve/type";
import { NoInfer } from "react-redux";
import { ApiPaginationResponse } from "types/api";
import { AnnoucementType, RetriveStateType } from "types/retrieve";

import {
  fetchAnnoucement,
  fetchBanner,
  fetchLogo,
  fetchWager,
} from "./retrieve.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<RetriveStateType>>
) => {
  builder.addCase(fetchAnnoucement.pending, (state: RetriveStateType) => {
    state.isAnnouncementLoading = true;
  });
  builder.addCase(
    fetchAnnoucement.fulfilled,
    (
      state: RetriveStateType,
      action: PayloadAction<
        ApiPaginationResponse<AnnoucementType[]> | undefined
      >
    ) => {
      state.isAnnouncementLoading = false;
      if (action.payload) {
        state.announcements = action.payload.data || null;
        state.totalAnnouncements = action.payload.totalCount;
      }
    }
  );

  builder.addCase(fetchBanner.pending, (state: RetriveStateType) => {
    state.isBannerLoading = true;
  });
  builder.addCase(
    fetchBanner.fulfilled,
    (
      state: RetriveStateType,
      action: PayloadAction<GetBannerResponse | undefined>
    ) => {
      state.isBannerLoading = false;
      state.banners = action.payload?.data || null;
    }
  );
  builder.addCase(fetchBanner.rejected, (state: RetriveStateType) => {
    state.isBannerLoading = false;
  });

  builder.addCase(
    fetchLogo.fulfilled,
    (
      state: RetriveStateType,
      action: PayloadAction<GetLogoResponse | undefined>
    ) => {
      if (action.payload?.data) {
        state.logo = action.payload?.data;
      }
    }
  );

  builder
    .addCase(fetchWager.pending, (state: RetriveStateType) => {
      state.isLoading = true;
    })
    .addCase(
      fetchWager.fulfilled,
      (state: RetriveStateType, action: PayloadAction<WagerResponseType>) => {
        state.isLoading = false;
        state.wager = { ...action.payload };
      }
    );
};
